//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObject.js";
import "../no/ObjectList.js";
import "../no/ObjectList.js";
SPLM.Features.VariableRadiusPointsBuilderList = class extends SPLM.ObjectList{
    constructor (c){
        super(c);
        this._d['Class'] = "SPLM.Features.VariableRadiusPointsBuilderList";
    }
}
export default SPLM;